var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"text-center success"},[_c('i',{staticClass:"far fa-thumbs-up"}),_c('h1',{staticClass:"mt-4"},[_vm._v("good!")]),_c('h3',[_vm._v("Success!!")]),_c('h4',[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }